ctaBanner = {
	init: function () {
		$(document).ready(function () {
			$('.js-cta-side-banner').attr('aria-visible', 'true');
		})
		$('.js-cta-side-banner-close-button').on('click', function() {
			$('.js-cta-side-banner').attr('aria-visible', 'false');
			$('.js-cta-side-banner').attr('aria-show-on-mobile', 'false');
		});
	}
}



// WEBPACK FOOTER //
// ./resources/js/modules/cta-banner.js